import ApiService from "../../services/ApiService"
import { isLoading, setError, setSuccessMessage } from "./uxAction"

export function createSkill({ skillName }, callback) {
    return async (dispatch) => {
        dispatch(isLoading(true))

        const resp = await ApiService.invokePost(process.env.REACT_APP_API_URL + `/admin/api/secured/skills`, {
            skillName
        })

        if (resp.status >= 400) {
            dispatch(setError(resp.data.errors))
        }

        dispatch(isLoading(false))

        if (callback)
            callback(resp.data.data)
    }
}

export function fetchAllSkillSelectable() {
    return async (dispatch) => {
        dispatch(isLoading(true))

        const resp = await ApiService.invokeGet(process.env.REACT_APP_API_URL + `/admin/api/secured/skills`)

        dispatch(isLoading(false))

        if (resp.status == 200) {
            const { data } = resp.data
            
            let selectableFormat = data.filteredData.map(c => ({
                label: c.name,
                value: c.name
            }))

            await dispatch({
                type: 'FETCH_SKILL_SELECTABLE',
                payload: selectableFormat
            })

        }


    }
}

export function fetchAllSkills({ query, page = 0, limit = 20 }, callback) {
    return async (dispatch) => {
        dispatch(isLoading(true))

        const resp = await ApiService.invokeGet(process.env.REACT_APP_API_URL + `/admin/api/secured/skills?query=${query}&page=${page}&limit=${limit}`)

        dispatch(isLoading(false))

        if (resp.status === 200) {
            const { data } = resp.data
            await dispatch({
                type: 'FETCH_SKILLS_TABLE',
                payload: data
            })


        if (callback)
            callback({
                filteredData: data.filteredData,
                totalFiltered: data.filteredData?.length,
                total: data.total
            })
        }
    }
}

export function bulkDeleteSkill({ skillIds = [] }, callback) {
    return async (dispatch) => {
        try {
            dispatch(isLoading(true))

            const resp = await ApiService.invokeDelete(process.env.REACT_APP_API_URL + `/admin/api/secured/skills`, {
                skillIds
            })

            dispatch(isLoading(false))

            if (resp.status == 200) {
                dispatch(setSuccessMessage({
                    title: "Success",
                    subTitle: "Item(s) deleted"
                }))
            }

            if (callback)
                callback()

        } catch (e) { }
    }
}

export function updateSkill({ skillId, skillName }, callback) {
    return async (dispatch) => {
        try {
            dispatch(isLoading(true))

            const resp = await ApiService.invokePatch(process.env.REACT_APP_API_URL + `/admin/api/secured/skills/${skillId}`, {
                skillName
            })

            dispatch(isLoading(false))

            if (resp.status >= 400)
                dispatch(setError(resp.data.errors))

            if (resp.status == 200) {
                dispatch(setSuccessMessage({
                    title: "Success",
                    subTitle: "updated successfully"
                }))
            }

            if (callback)
                callback()


        } catch (e) { }
    }
}